import { FormControl, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from 'util';

export function IsRequiredWithGenericMessage(control: FormControl): ValidationErrors {
  if (isNullOrUndefined(control.value) || control.value.trim() === '') {
    const errors: ValidationErrors = {};
    errors['required'] = 'Field is required';

    return errors;
  }
}